import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {EditableFormField} from 'shells/form/editable-form-field';
import {FormField} from 'shells/form/form-field';
import {ChevronDownIcon} from 'shells/icon';
import {TextField} from 'shells/textfield/textfield';

import {getInputStyles} from '../../../../helpers';

import styles from './field-styles.module.css';

type Props = {
    name: string;
    control: Control;
    watch: Watch;
    isRequired: boolean;
    // name of the subfield to identify which field to update
    subfieldKey: string;
    isDropdown?: boolean;
};

export function AddressFieldItem(props: Props) {
    const subfields = props.watch(`${props.name}.subfields`);
    const color = props.watch('inputStyle.color');
    const inputColor = props.watch('inputStyle.inputColor');
    const fontSize = props.watch('inputStyle.fontSize');
    const border = props.watch('inputStyle.border');
    const borderRadius = props.watch('inputStyle.borderRadius');

    return (
        <div style={{fontSize: `${fontSize}px`}}>
            <Controller
                name={`${props.name}.subfields`}
                control={props.control}
                rules={{
                    maxLength: {
                        value: 255,
                        message: 'Field names can’t exceed 255 characters',
                    },
                }}
                // @ts-expect-error
                render={({field: labelField, fieldState}) => {
                    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

                    const matchingField = labelField.value.find(
                        // @ts-expect-error
                        (subfield) => subfield.name === props.subfieldKey
                    );

                    return (
                        <EditableFormField
                            innerId={labelField.id}
                            label={matchingField && matchingField.label}
                            errorMessage={errorMessage}
                            smallBottomMargin={true}
                            editableLabelProps={{
                                onSaveNewValue: (newName) => {
                                    // @ts-expect-error
                                    const updatedFields = subfields.map((subfield) => {
                                        if (subfield.name === props.subfieldKey) {
                                            return {
                                                ...subfield,
                                                label: newName,
                                            };
                                        }

                                        return subfield;
                                    });

                                    return labelField.onChange(updatedFields);
                                },
                                placeholder: 'Add a title',
                                allowSavingEmpty: false,
                                shouldAllowUndo: false,
                                // address_2 is should never be required
                                required: props.subfieldKey !== 'address_2' && props.isRequired,
                                tooltip: null,
                                // @ts-expect-error
                                customStyle: {color},
                                isWhite: true,
                            }}
                        >
                            <Controller
                                name={`${props.name}.subfields`}
                                control={props.control}
                                rules={{
                                    maxLength: {
                                        value: 255,
                                        message: 'Placeholders can’t exceed 255 characters',
                                    },
                                }}
                                render={({
                                    // @ts-expect-error
                                    field: textFieldField,
                                    // @ts-expect-error
                                    fieldState: textFieldFieldState,
                                }) => {
                                    const textFieldErrorMessage = textFieldFieldState.error
                                        ? textFieldFieldState.error.message
                                        : undefined;

                                    const matchingTextField = textFieldField.value.find(
                                        // @ts-expect-error
                                        (subfield) => subfield.name === props.subfieldKey
                                    );

                                    return (
                                        <FormField
                                            innerId='placeholder'
                                            errorMessage={textFieldErrorMessage}
                                        >
                                            <div className='pos-relative flex align-center'>
                                                <TextField
                                                    value={
                                                        matchingTextField &&
                                                        matchingTextField.placeholder
                                                    }
                                                    // @ts-expect-error
                                                    style={getInputStyles({
                                                        borderRadius,
                                                        border,
                                                        fontSize,
                                                        color,
                                                        inputColor,
                                                    })}
                                                    onChange={(newPlaceholder) => {
                                                        const updatedFields = subfields.map(
                                                            // @ts-expect-error
                                                            (subfield) => {
                                                                if (
                                                                    subfield.name ===
                                                                    props.subfieldKey
                                                                ) {
                                                                    return {
                                                                        ...subfield,
                                                                        placeholder: newPlaceholder,
                                                                    };
                                                                }

                                                                return subfield;
                                                            }
                                                        );

                                                        textFieldField.onChange(updatedFields);
                                                    }}
                                                    selectOnFocus={true}
                                                />
                                                {props.isDropdown && (
                                                    <div
                                                        className={
                                                            styles[
                                                                'dropdown-chevron-outer-container'
                                                            ]
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                styles[
                                                                    'dropdown-chevron-inner-container'
                                                                ]
                                                            }
                                                        >
                                                            <ChevronDownIcon />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </FormField>
                                    );
                                }}
                            />
                        </EditableFormField>
                    );
                }}
            />
        </div>
    );
}
